module.exports = __webpack_public_path__ + "static/media/exclusion.0b427cab.svg";